<template>
    <div style="height: 100%;">
        <Header :showSwitch="true">
            <div slot="right" class="align-center">
                <user-popover></user-popover>
            </div>
        </Header>
        <div class="main-container">
          <router-view></router-view>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header'
import {mapActions, mapState} from "vuex";
import userPopover from '@/components/userPopover'
    export default {
        name: 'layout',
        data () {
            return {
                popVis: false,
            }
        },
        computed: {
          matchCondition () {
            // 有企业 企业已认证 是企业管理员
            return !!this.userInfo.orgId && (this.orgInfo.isAuthentication === 1) && (this.userInfo.type !== 0)
          },
            isAuthedOrg() {
                if (!this.orgInfo) {
                    return false;
                }
                return !!this.orgInfo.isAuthentication;
            },
            isAdmin() {
                if (!this.userInfo) {
                    return false;
                }
                return this.userInfo.type === 1 || this.userInfo.type === 2;
            },
            ...mapState('user',['userInfo','orgInfo'])
        },
        components: {
            Header,
            userPopover
        },
        watch: {
          userInfo: {
            immediate: true,
            handler (value) {
              if(value && value.id && !this.matchCondition) {
                this.$router.push('/chooseOrg')
              }
            }
          }
        },
        methods: {
            ...mapActions('user',['ExitUser']),
            toPlatform() {
                window.location.href=process.env.VUE_APP_SITE_HOST;
            },
            toAuth() {
                window.location.href=`${process.env.VUE_APP_SITE_HOST}/pc/platform/index.html#/recognize?orgId=${this.userInfo.orgId}`;

            },
            toRecognize () {
                window.location.href = process.env.VUE_APP_SITE_HOST + `/pc/platform/index.html#/recognize?orgId=${this.userInfo.orgId}`
            },
            async logout () {
                await this.ExitUser();
                this.$router.push({path:'/'})
            }
        }
    }
</script>

<style scoped lang="less">
    .main-container{
      position: relative;
      height: calc(100% - 70px);
      overflow-y: auto;
      background-color: #E7E8EB;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .pop-menu-item{
        height: 32px;
        color: #606266;
        font-size: 14px;
        cursor: pointer;
        line-height: 32px;
        padding-left: 10px;
        &:hover{
            color: #3389FF;
            background-color: rgba(51, 137, 255, 0.05);
        }
    }
    .company{
        color: rgba(0,0,0,0.65);
        margin: 1px 10px 15px;
    }
    .switch-title{
        margin-left: 10px;
        color: #909399;
        font-size: 12px;
    }
    .el-radio-group{
        width: 100%;
    }
    .el-radio{
        display: flex;
        justify-content: space-between;
        width: 100%;
        flex-direction: row-reverse;
        margin: 18px 0;
        color: #606266;
        font-size: 14px;
    }
    .current-tag{
        color: #3389FF;
        background-color: rgba(51, 137, 255, 0.2);
        font-size: 12px;
        width: 31px;
        height: 16px;
        line-height: 16px;
        border-radius: 5px;
        margin-left: 4px;
        display: inline-block;
        text-align: center;
    }
    .username{
        font-size: 14px;
        margin-left: 6px;
    }
    .unread-empty{
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #999;
    }
    .unread-msg-item{
        padding-left: 8px;
        margin: 3px 0;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        color: #5A5E66;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover{
            background-color: rgba(51, 137, 255, 0.1);
        }
    }

    .not-match-img{
        width: 320px;
        height: 181px;
        background-image: url("../assets/images/auth_defeat_icon.png");
        background-repeat: no-repeat;
        background-size: cover;
        margin-bottom: 44px;
    }
</style>
